import styled from 'styled-components'

const MenuPopupOptionUi = styled.option`
  color: rgba(10, 78, 125, 1);
`
export default MenuPopupOptionUi
